<template>
  <com-header :actived="2"></com-header>
  <div class="eBusiness-container inner-container">
    <inner-banner
      :img="bannerImg"
      title="招聘管理系统"
      brief="招聘管理系统可以为企业提供从职位发布到评估录用的一站式招聘服务，包括企业信息管理、职位管理、职位发布、简历收集、简历审核、面试通知等。系统为求职者提供个人信息管理、简历制作及管理、职位信息查询、企业信息查询、简历投递、应聘过程通知、个人简历访问控制等服务"
    ></inner-banner>
    <com-title class="mt-20" title="产品优势"></com-title>
    <div class="advantage-box mt-20">
      <div class="common-container flex justify-between">
        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.1s">
          <icon-card class="yellow-org" :img="img1" title="快速部署" brief="技术平台标准功能模块化产品，灵活配置，快速构建业务服务与应用"></icon-card>
        </div>
        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.2s">
          <icon-card class="yellow-org" :img="img1" title="结构化人才库" brief="协助企业搭建结构化人才库，完成人才信息储备"></icon-card>
        </div>

        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.3s">
          <icon-card class="yellow-org" :img="img1" title="智能人才筛选" brief="智能匹配职位人才，提高人才选拔效率"></icon-card>
        </div>
        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.4s">
          <icon-card class="yellow-org" :img="img1" title="一站式服务" brief="提供从职位发布到面试通知全流程服务"></icon-card>
        </div>
      </div>
    </div>

    <div class="yinyong-box mt-20">
      <div class="common-container">
        <com-title title="应用场景"></com-title>
        <ul class="mt-6">
          <li>本系统可作为政府部门为管辖区域内的企业和居民提供招聘和应聘的桥梁。基于政府部门对用人单位的资格审核，确保了招聘岗位的可信度，系统的隐私设置也进一步保护了求职者的个人信息。本系统在为辖区内企业更有效地完成招聘需求的同时，也从总体上为辖区吸引来更多的人才。<br>本系统完整的招聘应聘流程也同样适用于企业，帮助企业建立独立的人才库系统，完成招聘工作。</li>
        </ul>
      </div>
    </div>
    <div class="case-box">
      <div class="common-container">
        <com-title title="客户案例"></com-title>
        <div class="case-list flex justify-between">
          <div class="case-item  wow  bounceInUpSlow"      data-wow-delay="0.1s">
            <img src="@/assets/images/other/invite-case01.png" alt />
          </div>
          <div class="case-item  wow  bounceInUpSlow"   data-wow-delay="0.15s">
            <img src="@/assets/images/other/invite-case02.jpeg" alt />
          </div>
          <div class="case-item  wow  bounceInUpSlow"  data-wow-delay="0.2s">
            <img src="@/assets/images/other/invite-case03.jpeg" alt />
          </div>
          <div class="case-item  wow  bounceInUpSlow"  data-wow-delay="0.25s">
            <img src="@/assets/images/other/invite-case04.jpeg" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
  <com-footer></com-footer>
</template>
<script setup>
  import { Navigation,Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import bannerImg from '@/assets/images/product-banner.png'
import { ref } from 'vue'
import img1 from '@/assets/images/power-img01.png'
import img2 from '@/assets/images/power-img02.png'
import img3 from '@/assets/images/power-img03.png'
import img4 from '@/assets/images/power-img04.png'

const onSwiper = (swiper) => {
  // console.log(swiper);
};
const onSlideChange = () => {
  // console.log('slide change');
};
const modules = ref([Navigation,Pagination])
</script>
<style >
/* @import "@/assets/style/inner.less"; */
</style>